import { track } from './logEvent'
import { LoanEvent } from './events/loan'

type CreateApplicationResponse = {
    Status?: string
    LoanID?: string
    Loanid?: string
    loanid?: string
}

/**
 * /auth/createnewapplication 或 signupfrompreapp 建贷成功后打 LOAN_INSERT。
 * value / metadata.loan_id = 新贷款 id（若响应无 id，value 回退为 source）。
 */
export function trackLoanInsert(
    response: CreateApplicationResponse | null | undefined,
    source: string
): boolean {
    if (!response || response.Status !== 'OK') return false
    const loanId = (
        response.LoanID ||
        response.Loanid ||
        response.loanid ||
        ''
    ).toString()
    return track(LoanEvent.INSERT, loanId || source, {
        loan_id: loanId,
        source,
    })
}
